/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * 
 * @export
 * @interface ShipmentReturnModel
 */
export interface ShipmentReturnModel {
    /**
     * 
     * @type {string}
     * @memberof ShipmentReturnModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentReturnModel
     */
    shippingMethodId?: string;
    /**
     * 
     * @type {Price}
     * @memberof ShipmentReturnModel
     */
    price?: Price;
    /**
     * 
     * @type {string}
     * @memberof ShipmentReturnModel
     */
    shippingMethodName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShipmentReturnModel
     */
    pickupPointId?: string;
    /**
     * 
     * @type {Address}
     * @memberof ShipmentReturnModel
     */
    pickupPointAddress?: Address;
    /**
     * 
     * @type {string}
     * @memberof ShipmentReturnModel
     */
    shippingMethodType?: string;
}

/**
 * Check if a given object implements the ShipmentReturnModel interface.
 */
export function instanceOfShipmentReturnModel(value: object): boolean {
    return true;
}

export function ShipmentReturnModelFromJSON(json: any): ShipmentReturnModel {
    return ShipmentReturnModelFromJSONTyped(json, false);
}

export function ShipmentReturnModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentReturnModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'shippingMethodId': json['shippingMethodId'] == null ? undefined : json['shippingMethodId'],
        'price': json['price'] == null ? undefined : PriceFromJSON(json['price']),
        'shippingMethodName': json['shippingMethodName'] == null ? undefined : json['shippingMethodName'],
        'pickupPointId': json['pickupPointId'] == null ? undefined : json['pickupPointId'],
        'pickupPointAddress': json['pickupPointAddress'] == null ? undefined : AddressFromJSON(json['pickupPointAddress']),
        'shippingMethodType': json['shippingMethodType'] == null ? undefined : json['shippingMethodType'],
    };
}

export function ShipmentReturnModelToJSON(value?: ShipmentReturnModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'shippingMethodId': value['shippingMethodId'],
        'price': PriceToJSON(value['price']),
        'shippingMethodName': value['shippingMethodName'],
        'pickupPointId': value['pickupPointId'],
        'pickupPointAddress': AddressToJSON(value['pickupPointAddress']),
        'shippingMethodType': value['shippingMethodType'],
    };
}

